export default __webpack_public_path__ + "static/media/total-aum.f075224c.svg";